import Vue from 'vue';
import Router, { Route } from 'vue-router';
import { Component } from 'vue-property-decorator';
import { localizeRoutes } from '@/i18n/helpers';

Vue.use(Router);

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate',
]);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to: Route, from: Route, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash) {
      return {
        selector: to.hash,
      };
    } else {
      return { x: 0, y: 0 };
    }
  },
});

const routes: any = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '@/views/Home.vue'),
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '@/views/About.vue'),
  },
  {
    path: '/services',
    name: 'services',
    component: () => import(/* webpackChunkName: "services" */ '@/views/Services.vue'),
  },
  {
    path: '/vehicle-fleet',
    name: 'vehicle-fleet',
    component: () => import(/* webpackChunkName: "vehiclefleet" */ '@/views/VehicleFleet.vue'),
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import(/* webpackChunkName: "contact" */ '@/views/Contact.vue'),
  },
  {
    path: '/request',
    name: 'request',
    component: () => import(/* webpackChunkName: "request" */ '@/views/Request.vue'),
  },
  {
    path: '/error',
    name: 'error',
    component: () => import(/* webpackChunkName: "error" */ '@/views/Error.vue'),
  },
  {
    path: '/404',
    name: '404',
    component: () => import(/* webpackChunkName: "404" */ '@/views/NotFound.vue'),
  },
];

localizeRoutes(router, routes);
router.addRoutes(routes);

export default router;
